<ion-header [translucent]="true">
  <ion-toolbar class="lacademie-toolbar">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title style="font-size: 13px;">{{ title | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="false">
  @if (cancelReservationFeild == false && modifyReservationFeild == false) {
    <div  style="background-color: #f0f0f0;height: 100%;">
      <ion-card >
        <ion-card-header>
          @if (reservationConfirmed) {
            <ion-card-subtitle  style="font-size: 26px;"><b>Your Reservation has been confirmed</b></ion-card-subtitle>
          }
          @if (reservationNotAvailable) {
            <ion-card-subtitle style="font-size: 26px;"><b>Reservation not available</b></ion-card-subtitle>
          }
          <br>
            <!-- <ion-card-title><b>{{ selectedStore.displayName }}</b></ion-card-title> -->
            <!-- <ion-card-subtitle style="font-size:16px;">Reservation ID : {{reservationID}}</ion-card-subtitle> -->
          </ion-card-header>
          @if (reservationConfirmed) {
            <ion-card-content>
              <p style="font-size: 14px;"><strong>{{'ReservationPage.Name' | translate}}  : {{reservationGuestName}}</strong></p>
              <p style="font-size: 14px;"><strong>{{'fav.Phone' | translate}} : {{reservationGuestPhone}}</strong></p>
              <p style="font-size: 14px;"><strong>{{'fav.Email' | translate}} : {{reservationGuestEmail}}</strong></p>
              <p style="font-size: 14px;"><strong>{{'ReservationPage.TotalGuests' | translate}} : {{reservationGuestsCount}}</strong></p>
              <p style="font-size: 14px;"><strong>{{'ReservationPage.Children' | translate}} : {{reservationCountChildren}}</strong></p>
              <p style="font-size: 14px;"><strong>{{'ReservationPage.HighChair' | translate}} : {{reservationCountHighChair}}</strong></p>
              <p style="font-size: 14px;"><strong>Booster : {{reservationCountBooster}}</strong></p>
              <p style="font-size: 14px;"><strong>{{'ReservationPage.SpecialRequests' | translate}} : {{reservationSpecialRequests}}</strong></p>
              @if (reservationCancelled == false) {
                <p style="font-size: 14px;"><strong>{{'ReservationPage.ReservationTime' | translate}} : {{reservationDateTime.toDateString()}} {{'ReservationPage.At' | translate}} {{reservationDateTime.toLocaleTimeString()}}</strong></p>
              }
            </ion-card-content>
          }
          @if (reservationConfirmed) {
            <ion-card-content>
              <button  style="margin-left: 5px; background-color: #96af18; color: white;" type="button" mat-raised-button color="accent" (click)="openModifiyReservationFeild()">Modify Reservation</button>
              <button  style="margin-left: 5px; background-color: #96af18; color: white;" type="button" mat-raised-button color="accent" (click)="openCancelReservationFeild()">Cancel Reservation</button>
            </ion-card-content>
          }
        </ion-card>
      </div>
    }
    @if (cancelReservationFeild == true && modifyReservationFeild == false && reservationConfirmed) {
      <div  style="background-color: #f0f0f0;height: 100%;">
        <ion-card >
          <ion-card-header>
            @if (reservationCancelled == false) {
              <ion-card-subtitle  style="font-size: 26px;"><b>Are you sure to cancel the reservation?</b></ion-card-subtitle>
            }
            @if (reservationCancelled == true) {
              <ion-card-subtitle  style="font-size: 26px;"><b>Your Reservation has been cancelled</b></ion-card-subtitle>
            }
            <br>
            </ion-card-header>
            @if (reservationCancelled == false) {
              <ion-card-content>
                <button  style="margin-left: 5px; background-color: #96af18; color: white;" type="button" mat-raised-button color="accent" (click)="closeCancelReservationFeild()">No, Go back</button>
                <button  style="margin-left: 5px; background-color: #96af18; color: white;" type="button" mat-raised-button color="accent" (click)="cancelReservation()">Yes, Cancel reservation</button>
              </ion-card-content>
            }
          </ion-card>
        </div>
      }
      @if (cancelReservationFeild == false && modifyReservationFeild == true && reservationConfirmed) {
        <div  style="background-color: #f0f0f0;height: 100%;">
          @if (reservationUpdateSuccessfull == false) {
            <ion-card>
              <ion-card-header>
                @if (reservationCancelled == false) {
                  <ion-card-subtitle  style="font-size: 26px;"><b>Modify Reservation</b></ion-card-subtitle>
                }
                <br>
                </ion-card-header>
                <ion-card-content>
                  @if (reservationCancelled == false) {
                    <p style="font-size: 14px;"><strong>{{'ReservationPage.ReservationTime' | translate}} : {{reservationTime.toDateString()}} {{'ReservationPage.At' | translate}} {{reservationTime.toLocaleTimeString()}}</strong></p>
                  }
                  <mat-form-field appearance="fill" style="font-size: 14px; width: 170px; padding: 3px;">
                    <mat-label>{{'ReservationPage.Name' | translate}}</mat-label>
                    <input  type="text" matInput name="guestName" [(ngModel)]="guestName">
                  </mat-form-field>
                  <mat-form-field appearance="fill" style="font-size: 14px; width: 170px; padding: 3px;">
                    <mat-label>{{'fav.Phone' | translate}}</mat-label>
                    <input  type="text" matInput name="guestPhone" [(ngModel)]="guestPhone">
                  </mat-form-field>
                  <mat-form-field style="font-size: 14px; width: 170px; padding: 3px;" appearance="fill">
                    <mat-label>{{ 'ReservationPage.Guests' | translate}}</mat-label>
                    <input type="number" matInput name="reservationGuests"  min="1" max="100"  [(ngModel)]="reservationGuests"/>
                  </mat-form-field>
                </ion-card-content>
                <ion-card-content >
                  <mat-form-field style="font-size: 14px; width: 170px; padding: 3px;" appearance="fill">
                    <mat-label>{{'ReservationPage.Children' | translate}}</mat-label>
                    <input type="number" matInput name="countChildren"  min="0" max="20"  [(ngModel)]="countChildren"/>
                  </mat-form-field>
                  <mat-form-field style="font-size: 14px; width: 170px; padding: 3px;" appearance="fill">
                    <mat-label>{{'ReservationPage.HighChair' | translate}}</mat-label>
                    <input type="number" matInput name="countHighChair"  min="0" max="20"  [(ngModel)]="countHighChair"/>
                  </mat-form-field>
                  <mat-form-field style="font-size: 14px; width: 170px; padding: 3px;" appearance="fill">
                    <mat-label>Booster</mat-label>
                    <input type="number" matInput name="countBooster"  min="0" max="20"  [(ngModel)]="countBooster"/>
                  </mat-form-field>
                </ion-card-content>
                <ion-card-content >
                  <mat-form-field style="font-size: 14px; width: 250px; padding: 3px;" appearance="fill">
                    <mat-label>{{'ReservationPage.SpecialRequests' | translate}}</mat-label>
                    <textarea matInput  name="specialRequests" [(ngModel)]="specialRequests" ></textarea>
                  </mat-form-field>
                  <!-- <p style="font-size: 14px;"><strong>{{'ReservationPage.ReservationTime' | translate}} : {{this.reservationDate.toDateString()}} {{'ReservationPage.At' | translate}} {{reservationHour}}</strong></p> -->
                </ion-card-content>
                @if (reservationCancelled == false) {
                  <ion-card-content>
                    <button  style="margin-left: 5px; background-color: #96af18; color: white;" type="button" mat-raised-button color="accent" (click)="closeModifyReservationFeild()">Go Back</button>
                    <button  style="margin-left: 5px; background-color: #96af18; color: white;" type="button" mat-raised-button color="accent"(click)="modifyReservation()" >Modify Reservation</button>
                  </ion-card-content>
                }
              </ion-card>
            }
            @if (reservationUpdateSuccessfull == true) {
              <ion-card>
                <ion-card-header>
                  <ion-card-subtitle style="font-size: 26px;"><b>Your Reservation has been modified</b></ion-card-subtitle>
                  <br>
                  </ion-card-header>
                  <ion-card-content>
                    <p style="font-size: 14px;"><strong>{{'ReservationPage.Name' | translate}}  : {{guestName}}</strong></p>
                    <p style="font-size: 14px;"><strong>{{'fav.Phone' | translate}} : {{guestPhone}}</strong></p>
                    <p style="font-size: 14px;"><strong>{{'fav.Email' | translate}} : {{currentAgenda.Email}}</strong></p>
                    <p style="font-size: 14px;"><strong>{{'ReservationPage.TotalGuests' | translate}} : {{reservationGuests}}</strong></p>
                    <p style="font-size: 14px;"><strong>{{'ReservationPage.Children' | translate}} : {{countChildren}}</strong></p>
                    <p style="font-size: 14px;"><strong>{{'ReservationPage.HighChair' | translate}} : {{countHighChair}}</strong></p>
                    <p style="font-size: 14px;"><strong>Booster : {{countBooster}}</strong></p>
                    <p style="font-size: 14px;"><strong>{{'ReservationPage.SpecialRequests' | translate}} : {{specialRequests}}</strong></p>
                    @if (reservationCancelled == false) {
                      <p style="font-size: 14px;"><strong>{{'ReservationPage.ReservationTime' | translate}} : {{reservationTime.toDateString()}} {{'ReservationPage.At' | translate}} {{reservationTime.toLocaleTimeString()}}</strong></p>
                    }
                  </ion-card-content>
                </ion-card>
              }
            </div>
          }

        </ion-content>